<template>
	<div class="bot">
		<span class="bottom-txt" style="color: white;text-decoration: none;">Copyright © 2020 四川浪鲸智能科技有限公司版权所有 lagenai.com All Rights Reserved.
		</span>
		<span class="bottom-txt" style="color: white;text-decoration: none;">ICP备案号：<a style="color: white;text-decoration: none;" href="http://www.beian.miit.gov.cn">蜀ICP备20022004号-2</a></span>
	</div>
</template>

<script>
	export default {
		data(){
			return {
				time:(new Date).getFullYear()
			}
		}
	}
</script>

<style scoped="scoped">
	.bottom-txt {
		font-size: 8px;
		color: white;
	}
	
	.bot {
		position: absolute;
		bottom: 0px;
		width: 100vw;
		height: 10vh;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		background-color: #212a37;
	}
</style>
